import React, { useState, useEffect } from 'react';
import { WhatsappIcon } from './icons/WhatsappIcon';
import { useTranslation } from '../i18n/LanguageContext';

const WHATSAPP_BUSINESS_LINK = "https://wa.me/message/TINGCS2EHASRK1";

export const FloatingWhatsAppButton: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  return (
    <a
      href={WHATSAPP_BUSINESS_LINK}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t('whatsapp.floatingAriaLabel')}
      className={`
        fixed bottom-6 right-6 z-50
        flex items-center justify-center
        w-14 h-14 bg-whatsapp-green rounded-full
        shadow-2xl
        transition-all duration-300 ease-[cubic-bezier(0.25,1,0.5,1)]
        transform focus:outline-none focus:ring-4 focus:ring-whatsapp-green/50
        ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'}
        hover:shadow-lg hover:scale-110
      `}
    >
      <WhatsappIcon className="w-8 h-8 text-white" />
    </a>
  );
};